import { render, staticRenderFns } from "./EventAdd.vue?vue&type=template&id=dc8d9fe2&scoped=true&"
import script from "./EventAdd.vue?vue&type=script&lang=js&"
export * from "./EventAdd.vue?vue&type=script&lang=js&"
import style0 from "./EventAdd.vue?vue&type=style&index=0&id=dc8d9fe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8d9fe2",
  null
  
)

export default component.exports